import * as React from 'react'
import { Elements } from '@tfo/common'

import FaqButton from '../common/faq-button/FaqButton'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import './Footer.scss'
import CookieInformation from '../disclaimer/CookieInformation'


const Footer = ({ intl }: WrappedComponentProps) => (
	<div>
		<FaqButton />
		
			<CookieInformation></CookieInformation>
		
		<footer className="Footer">
			<Elements.Paragraph className="Footer__Text">
				{intl.formatMessage({ id: 'common.footer' })}
			</Elements.Paragraph>
		</footer>
	</div>
)

export default injectIntl(Footer)
